import $ from 'jquery';
import Util from 'root/module/util';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'filters',

    mode: 'index', // index, roadmap
    sort_by: 'date', // date, vote, trending
    status: null,
    categories: [],

    events: {
        'click .dropdown-sort li'     : 'onSelectSortBy',
        'click .dropdown-status li'   : 'onSelectStatus',
        'click .dropdown-category li' : 'onSelectCategory'
    },

    dom_handlers: {
        onSelectSortBy: function(e) {
            this.sort_by = $(e.currentTarget).data('val');
            this.trigger('change:sort_by', this.sort_by);

            this.render();
        },

        onSelectStatus: function(e) {
            var status_id = $(e.currentTarget).data('val');
            this.status = Cache.portal_status.get(status_id);

            this.trigger('chagne:status', this.status);
        },

        onSelectCategory: function(e) {
            var category = $(e.currentTarget).text();
            var index    = this.categories.indexOf(category);

            if (index === -1) {
                this.categories.push(category);
            } else {
                this.categories.splice(index, 1);
            }

            this.trigger('change:categories', this.categories);

            this.render();
        }
    },

    initialize: function(options) {
        this.mode       = options.mode;
        this.sort_by    = options.sort_by;
        this.categories = options.categories;
        this.embed      = options.embed;

        if (this.embed === 'widget') {
            this.status = Cache.portal_status.at(0);
        }
    },

    getSortByText: function() {
        switch (this.sort_by) {
            case 'date':
                return 'Latest';
            case 'vote':
                return 'Top Rated';
            case 'trending':
                return 'Trending';
            case 'DESC':
                return 'Newest first';
            case 'ASC':
                return 'Oldest first';
        }
    },

    setOptions: function(options) {
        this.sort_by = options.sort_by;
        return this;
    },


    renderAnnouncementCategories: function() {
        Cache.app.request({
            action: 'portal_announcement/count',
            data: {
                search: this.search
            },
            success: (response) => {
                var category_options = '';

                if (response.length) {
                    response.forEach(function(option) {
                        category_options += '<li' + (this.categories.indexOf(option.category) === -1 ? '' : ' class="selected"') + '>' + option.category + '</li>';
                    }, this);
                } else {
                    category_options += '<li class="disabled">No tags created</li>';
                }

                this.$el.find('.dropdown-category').html(category_options);
            }
        });
    },

    render: function() {
        var portal_embed  = this.mode === 'index' && this.embed === 'widget';
        var roadmap_embed = this.mode === 'roadmap' && this.embed === 'widget';
        var announcement_embed = this.mode === 'announcement' && this.embed === 'widget';

        var content =
        '<div class="button-dropdown button-dropdown-left">' +
            '<button type="button" class="dropdown-select font-weight-medium">' +
                (this.sort_by === 'date'     ? '<i class="fa-solid fa-sort-size-down text-icon margin-right-8"></i>' : '') +
                (this.sort_by === 'trending' ? '<i class="fa-solid fa-chart-line text-icon margin-right-8"></i>' : '') +
                (this.sort_by === 'vote    ' ? '<i class="fa-solid fa-star text-icon margin-right-8"></i>' : '') +
                this.getSortByText() +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-sort">' +
                    '<li class="dropdown-title">Sort by</li>' +
                    (this.mode === 'announcement' ? (
                        '<li' + (this.sort_by === 'ASC' ? ' class="selected"' : '') + ' data-val="ASC">Oldest first</li>' +
                        '<li' + (this.sort_by === 'DESC' ? ' class="selected"' : '') + ' data-val="DESC">Newest first</li>' )
                        : (
                        '<li' + (this.sort_by === 'date' ? ' class="selected"' : '') + ' data-val="date"><i class="fa-solid fa-fw fa-sort-size-down"></i>Latest</li>' +
                        '<li' + (this.sort_by === 'trending' ? ' class="selected"' : '') + ' data-val="trending"><i class="fa-solid fa-fw fa-chart-line"></i>Trending</li>' +
                        '<li' + (this.sort_by === 'vote'     ? ' class="selected"' : '') + ' data-val="vote"><i class="fa-solid fa-fw fa-star"></i>Top Rated</li>')) +
                '</ul>' +
            '</div>' +
        '</div>';

        if (portal_embed) {
            content +=
                '<div class="button-dropdown">' +
                    '<button type="button" class="dropdown-select font-weight-medium"><i class="fas fa-hashtag text-icon margin-right-8"></i>Categories</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-category">' +
                            Cache.feedback_category.models.map((option) => {
                                if (Cache.portal.at(0).get('categories').split(',').indexOf(option.get('name')) === -1) {
                                    return '';
                                } else {
                                    return '<li' + (this.categories.indexOf(option.get('name')) === -1 ? '' : ' class="selected"') + '>' + option.escape('name') + '</li>';
                                }
                            }).join('') +
                        '</ul>' +
                    '</div>' +
                '</div>';
        }

        if (announcement_embed) {
            content +=
                '<div class="button-dropdown">' +
                    '<button type="button" class="dropdown-select font-weight-medium"><i class="fas fa-hashtag text-icon margin-right-8"></i>Tags:</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-category"></ul>' +
                    '</div>' +
                '</div>';
        }

        if (roadmap_embed) {
            content +=
                '<div class="button-dropdown" data-update="true">' +
                    '<button type="button" class="dropdown-select font-weight-medium"><span class="workflow-option-colour" style="background-color:' + this.status.escape('colour') + ';"></span>' + this.status.escape('status_name') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-status">' +
                            Cache.portal_status.map((model) => {
                                return '' +
                                '<li data-val="' + model.id + '"' + (model.id === this.status.id ? ' class="selected"' : '') + '>' +
                                    '<span class="workflow-option-colour" style="background-color:' + model.escape('colour') + ';"></span>' +
                                    model.escape('status_name') +
                                '</li>';
                            }).join('') +
                        '</ul>' +
                    '</div>' +
                '</div>';
        }

        this.$el.html(content);

        if (portal_embed || roadmap_embed || announcement_embed) {
            this.$el.addClass('grid-6-6 grid-gap-8');
        }

        if (announcement_embed) {
            this.renderAnnouncementCategories();
        }

        return this;
    }
});